import { useEffect, useState } from 'react'
import { Box, Flex } from 'theme-ui'
import { useAnalytics } from '@chordcommerce/react-autonomy'
import { RadioGroup, Radio } from '@nextui-org/react'
import { toUsdCurrency } from '~/utils/formatters'
import DOMPurify from 'isomorphic-dompurify'
import parse from 'html-react-parser'

const VariantOptions = ({
  isLoading,
  options,
  setSelectedSku,
  customRadioLabel,
}) => {
  const [selected, setSelected] = useState(null)
  const { trackVariantClicked } = useAnalytics()
  const handleVariantClicked = (variant) => {
    trackVariantClicked({ product: { variant: variant } })
    setSelectedSku(variant.sku)
  }

  useEffect(() => {
    const preSelectedOption = options?.[0]
    if (preSelectedOption) {
      handleVariantClicked(preSelectedOption)
      setSelected(preSelectedOption.sku)
    }
  }, []) // eslint-disable-line

  return (
    <Box>
      <Flex
        sx={{
          alignItems: 'center',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
        }}
      >
        <RadioGroup
          label={
            customRadioLabel ||
            'Choose number of report credits to buy... credits never expire!'
          }
          value={selected}
          onValueChange={setSelected}
          className="my-3 font-medium"
          isDisabled={isLoading}
        >
          {options &&
            options.map((option) => {
              const { price, quantity, sku } = option

              function getDiscountMessage(quantity: string) {
                switch (quantity) {
                  case '3':
                    return ' (save over 30%!)'
                  case '5':
                    return ' (save 40%!)'
                  default:
                    return ''
                }
              }

              return (
                <Box key={`variant-option-${sku}`} mx={1}>
                  <div className="flex flex-col gap-3">
                    <Radio
                      value={sku}
                      onClick={() => handleVariantClicked(option)}
                      className={selected === sku ? 'font-bold' : ''}
                    >
                      {option.radioLabelText ? (
                        <>
                          {parse(DOMPurify.sanitize(option.radioLabelText))}
                        </>
                      ) : (
                        <>
                          {quantity === '1' && (
                            <span className="line-through text-pl-gray mr-1">
                              $129
                            </span>
                          )}
                          {`${toUsdCurrency(
                            price
                          )} for ${quantity} PropertyLens Report${
                            quantity > 1 ? 's' : ''
                          }${getDiscountMessage(quantity)}`}
                        </>
                      )}
                    </Radio>
                  </div>
                </Box>
              )
            })}
        </RadioGroup>
      </Flex>
    </Box>
  )
}

export default VariantOptions
